import { Icon, Carousel } from 'antd-mobile';

import { appMethod as app, appInstance } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import utils from '@utils/util';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './GpGoodsDetail.less';

export default class GpGoodsDetail extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '商品详情'
    },
    addToShoppingCartHidden: true,
    addToGroupBuyCart: true,
    displayComment: true,
    imageOrVideo: 'image',
    ifOpenNewGroup: true,
    showTips: true,
    team_token: '',
    discountInfo: [],
    discountInfoArr: [],
    storeStyle: '',
    formid: [],
    isShowTopBar: true,
    selectModelInfo: {
      models: [],
      stock: '',
      price: '',
      virtualPrice: '',
      buyCount: 1,
      models_text: '',
      leader_price: 0,
      member_price: 0,
      num_of_people: 0,
      groupBuyCount: 1,
      groupNum: ''
    },
    progress: '',
    teamInfo: {
      team_list: [],
      is_more: 1,
      curpage: 1,
      loading: false
    },
    imageOrVideo: 'image',
    scrollType: 'goods',
    carouselCurrentIndex: 1,
    isParticipate: false,
    isGroupMask: false,
    defaultPhoto: '',
    rect: [],
    screenHeight: 667
  }
  seckillFunc = []
  page = 1
  isMore = 1
  allStock = ''

  constructor(props) {
    super(props);
    document.title = '商品详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    var _this = this,
      goodsId = options.goods_id,
      franchiseeId = options.franchisee,
      activityId = options.activity_id,
      defaultPhoto = app.getDefaultPhoto()
    var height = app.getSystemInfoData().screenHeight || 667
    _this.setData({
      team_token: options.teamToken || '',
      goodsId: goodsId || '',
      franchiseeId: franchiseeId || '',
      defaultPhoto: defaultPhoto,
      activityId: activityId,
      screenHeight: height,
      sessionFrom: options.franchisee || app.getAppId() || '',
      'topNavBarData.totalHeight': app.globalData.topNavBarHeight || 0
    })
    _this.loadAll()
  }

  loadAll = () => {
    var _this = this
    _this.getAppECStoreConfig()
    _this.loadGoods()
  }
  loadGoods = () => {
    var _this = this,
      goodsModel = [],
      selectModels = [],
      modelStrs = {},
      description = '',
      modifySelectModels = '',
      price = 0,
      allStock = 0,
      selectStock,
      selectPrice,
      selectModelId,
      matchResult,
      selectVirtualPrice,
      selectText = '',
      selectGroupNum,
      leaderPrice,
      memberPrice,
      numOfPeople,
      i,
      j,
      selectImgurl = ''
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/getGoods',
      data: {
        activity_id: _this.data.activityId,
        goods_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId || '',
        team_token: _this.data.team_token
      },
      header: {
        activity_id: _this.data.activityId
      },
      success: res => {
        var goods = res.data.goods_info,
          groupData = res.data.group_buy_goods_info,
          discountInfo = groupData.discount_info,
          discountInfoArr = [],
          progress =
            Number(res.data.current_user_count / res.data.max_user_num) * 100,
          team_token = res.data.team_token,
          compid = 'goodsData'
        goods.downCount = {
          hours: '00',
          minutes: '00',
          seconds: '00',
          days: '00'
        }
        description = goods.description
        goods.server_time = res.current_time
        goods.seckill_end_time = utils.formatTime(
          new Date(res.data.end_date * 1000)
        )
        goods.seckill_start_time = utils.formatTime(
          new Date(res.data.start_date * 1000)
        )
        goods.status = res.data.status
        if (goods.status == 0 || goods.status == 1 || goods.status == 2) {
          _this.downcount = _this.beforeGroupDownCount(
            goods,
            res.data,
            _this,
            'goodsInfo'
          )
        } else if (goods.status == 3) {
          if (res.data.end_date != '-1') {
            _this.downcount = _this.duringGroupDownCount(
              goods,
              _this,
              'goodsInfo'
            )
          }
        }
        description = description
          ? description.replace(/\u00A0|\u2028|\u2029|\uFEFF/g, '')
          : description
        goods.description = description
        goods.virtual_price =
          goods.virtual_price == '0.00' && goods.virtual_price
            ? ''
            : goods.virtual_price
        for (var key in goods.model) {
          if (key) {
            var model = goods.model[key]
            goodsModel.push(model)
            if (model && model.subModelName) {
              modelStrs[model.id] = model.subModelName.join('、')
              selectModels.push(model.subModelId[0])
              modifySelectModels = selectModels.toString()
              selectText += '“' + model.subModelName[0] + '” '
            }
          }
        }
        if (goods.model_items.length) {
          var items = goods.model_items
          for (i = 0, j = items.length; i < j; i++) {
            price = items[i].price
            goods.highPrice = goods.highPrice > price ? goods.highPrice : price
            goods.lowPrice = goods.lowPrice < price ? goods.lowPrice : price
            allStock += Number(items[i].stock)
            if (i == 0) {
              selectPrice = price
              selectGroupNum = Number(items[i].num_of_people)
              memberPrice = items[i].member_price || 0
              leaderPrice = items[i].leader_price || 0
              selectStock = items[0].stock
              selectModelId = items[0].id
              selectImgurl = items[i].img_url
              selectVirtualPrice =
                items[i].virtual_price != '0.00' && items[i].virtual_price
                  ? items[i].virtual_price
                  : ''
            }
          }
          allStock = allStock / groupData.num_of_people.length
        } else {
          selectPrice = goods.price
          selectStock = goods.stock
          selectImgurl = goods.cover
          selectGroupNum = Number(
            discountInfo[0].num_of_people || groupData.goods_num
          )
          memberPrice = discountInfo[0].member_price || 0
          leaderPrice = discountInfo[0].leader_price || 0
          selectVirtualPrice =
            goods.virtual_price != '0.00' && goods.virtual_price
              ? goods.virtual_price
              : ''
        }
        for (var i = 0; i < discountInfo.length; i++) {
          if (discountInfo[i].model_id == selectModelId) {
            discountInfoArr.push(discountInfo[i])
          }
        }
        goods.model = goodsModel
        let expressSort = goods.goods_express_data.express_fee_sort
        if (expressSort.length == 1) {
          let express = expressSort[0]
          if (express == 0) {
            goods.express_fee = '包邮'
          } else {
            goods.express_fee = express + '元'
          }
        } else {
          goods.express_fee = expressSort[0] + '~' + expressSort[1] + '元'
        }
        _this.setData({
          'selectModelInfo.models': selectModels || '',
          'selectModelInfo.stock': selectStock || '',
          'selectModelInfo.price': selectPrice || '',
          'selectModelInfo.groupNum': selectGroupNum || '',
          'selectModelInfo.modelId': selectModelId || '',
          'selectModelInfo.models_text': selectText || '',
          'selectModelInfo.imgurl': selectImgurl || '',
          'selectModelInfo.virtualPrice': selectVirtualPrice || '',
          'selectModelInfo.leader_price': leaderPrice || 0,
          'selectModelInfo.member_price': memberPrice || 0,
          'selectModelInfo.num_of_people': selectGroupNum,
          goods: res.data,
          goodsInfo: goods,
          discountInfoArr: discountInfoArr,
          team_token: team_token || '',
          groupInfo: groupData,
          discountInfo: groupData.discount_info,
          progress: progress
        })
        _this.getAssessList(0, 1)
        if (res.data.type == '4' || res.data.type == '3') {
        } else {
          _this.loadTeamList(goods.id, groupData.activity_id, this.pageSize)
        }
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config,
        hidestock:
          res.detail_fields && res.detail_fields.stock == 0 ? true : false,
        isShowVirtualPrice:
          res.detail_fields && res.detail_fields.virtual_price == 1
            ? true
            : false
      })
    }, this.data.franchiseeId)
  }
  beforeGroupDownCount = (formData, res, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.seckill_start_time,
        showDays: true,
        callback: function() {
          let newData = {}
          newData[path + '.status'] = 3
          newData[path + '.current_status'] = 3
          newData[path + '.server_time'] = formData.seckill_start_time
          page.setData(newData)
          page.loadGoods()
          formData.server_time = formData.seckill_start_time
          if (res.end_date != '-1') {
            _this.downcount = _this.duringGroupDownCount(formData, page, path)
          }
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  duringGroupDownCount = (formData, page, path) => {
    let _this = this,
      downcount
    downcount = app.seckillDownCount(
      {
        startTime: formData.server_time,
        endTime: formData.seckill_end_time,
        showDays: true,
        callback: function() {
          let newData = {}
          newData[path + '.status'] = 4
          newData[path + '.current_status'] = 4
          page.setData(newData)
        }
      },
      page,
      path + '.downCount'
    )
    return downcount
  }
  loadTeamList = (goodsId, activityId) => {
    var _this = this,
      teamInfo = this.data.teamInfo
    if (teamInfo.is_more == 0 && teamInfo.loading) {
      return
    }
    this.setData({
      'teamInfo.loading': true
    })
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/getTeamListByGoods',
      data: {
        activity_id: activityId,
        goods_id: goodsId,
        sub_shop_app_id: _this.data.franchiseeId || '',
        page: this.page,
        page_size: 2
      },
      success: res => {
        let rdata = res.data,
          newdata = {},
          teamList = teamInfo.team_list,
          length = teamList.length,
          downcountArr = _this.downcountArr || []
        for (let i = 0; i < rdata.length; i++) {
          let f = rdata[i],
            dc,
            teamLen = i + length
          f.description = ''
          f.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00'
          }
          f.server_time = res.current_time
          f.seckill_end_time = utils.formatTime(new Date(f.expired_time * 1000))
          let path = 'teamInfo.team_list[' + teamLen + ']'
          dc = app.seckillDownCount(
            {
              startTime: f.server_time,
              endTime: f.seckill_end_time,
              callback: function() {
                let data = {}
                data[path + '.current_status'] = 3
                data['teamInfo.count'] = teamInfo.count - 1
                _this.setData(data)
              }
            },
            _this,
            path + '.downCount'
          )
          dc && downcountArr.push(dc)
        }
        newdata['teamInfo.team_list'] = teamList.concat(res.data)
        newdata['teamInfo.count'] = res.count
        newdata['teamInfo.is_more'] = res.is_more
        newdata['teamInfo.curpage'] = 1
        newdata['teamInfo.loading'] = false
        _this.downcountArr = downcountArr
        _this.setData(newdata)
        _this.page++
        _this.getRect()
      }
    })
  }
  showMoreTeams = () => {
    var pageSize = 10 + this.pageSize
    this.loadTeamList(this.data.goodsId, this.data.activityId, pageSize)
    this.pageSize = pageSize
  }
  singleBuy = () => {
    this.showCartHidden()
    this.setData({
      isGroupMask: false,
      isShowTopBar: false
    })
  }
  showProductSpecify = () => {
    this.showCartHidden()
    this.setData({
      isGroupMask: true
    })
  }
  groupBuy = () => {
    this.showCartHidden()
    this.setData({
      isGroupMask: true
    })
  }
  showCartHidden = () => {
    this.setData({
      addToShoppingCartHidden: false,
      ifAddToShoppingCart: true,
      imageOrVideo: 'image'
    })
  }
  hiddeAddToShoppingCart = () => {
    this.setData({
      addToShoppingCartHidden: true,
      isShowTopBar: true
    })
  }
  participateGroup = e => {
    var dataset = e.currentTarget.dataset
    if (dataset.joined == '1') {
      if (dataset.type == '1') {
        app.showModal({
          content: '您已参加过拼团活动，无法参加该新人团'
        })
        return
      } else {
        app.showModal({
          content: '您已参加过该团，不能重新参团'
        })
        return
      }
    }
    this.setData({
      addToGroupBuyCart: false,
      ifOpenNewGroup: false,
      isParticipate: true,
      isShowTopBar: false,
      'selectModelInfo.groupNum': e.currentTarget.dataset.num,
      team_token: e.currentTarget.dataset.token
    })
    this.resetSelectCountPrice()
  }
  hideGroupBuyCart = () => {
    this.setData({
      addToGroupBuyCart: true,
      isShowTopBar: true
    })
  }
  showMoreTips = () => {
    var showTips = !this.data.showTips
    this.setData({
      showTips: showTips
    })
  }
  hideMask = () => {
    this.setData({
      showTips: true
    })
  }
  getRect = () => {
    this.selectQuery('goods')
    this.selectQuery('group')
    this.selectQuery('comment')
    this.selectQuery('detail')
  }
  selectQuery = id => {
    const _this = this
    const idIndex = {
      goods: 0,
      group: 1,
      comment: 2,
      detail: 3
    };
    app.getBoundingClientRect('#' + id, ([res]) => {
      var newdata = {},
        compid = id
      newdata['rect[' + idIndex[compid] + '].top'] = res ? res.top : 0
      newdata['rect[' + idIndex[compid] + '].name'] = compid
      _this.setData(newdata)
    })
    document.documentElement.scrollTop = document.documentElement.scrollTop;
    document.body.scrollTop = document.body.scrollTop;
  }

  goToPlaylaws = () => {
    var path =
      '/group/pages/gpplaylaws/gpplaylaws?activityType=' +
      this.data.goods.type +
      '&autoRefund=' +
      this.data.goods.auto_refund +
      '&refundMode=' +
      this.data.goods.refund_mode +
      (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : '')
    this.saveUserFormId(function() {
      app.turnToPage(path)
    })
  }
  hiddeAddToShoppingCart = () => {
    this.setData({
      addToShoppingCartHidden: true,
      isShowTopBar: true
    })
  }
  carouselIndex = index => {
    this.setData({
      carouselCurrentIndex: index + 1
    })
  }
  showQRCodeComponent = () => {
    let that = this
    let goodsInfo = this.data.goodsInfo
    let groupInfo = this.data.groupInfo
    // let animation = app.createAnimation({
    //   timingFunction: 'ease',
    //   duration: 400
    // })
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/getShareQRCode',
      data: {
        goods_id: that.data.goodsId,
        activity_id: that.data.activityId,
        sub_shop_app_id: that.data.franchiseeId || '',
        virtual_price: (goodsInfo.virtual_price =
          '0.00' && goodsInfo.virtual_price
            ? goodsInfo.price
            : goodsInfo.virtual_price),
        type: 6,
        text: goodsInfo.title,
        price: groupInfo.group_buy_price,
        goods_img: goodsInfo.img_urls ? goodsInfo.img_urls[0] : goodsInfo.cover,
        user_token: app.globalData.PromotionUserToken || ''
      },
      success: function(res) {
        // animation.bottom('0').step()
        // that.setData({
        //   'pageQRCodeData.shareDialogShow': 0,
        //   'pageQRCodeData.shareMenuShow': true,
        //   'pageQRCodeData.goodsInfo': res.data,
        //   'pageQRCodeData.animation': animation.export()
        // })
        appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': res.data
          }
        });
      }
    })
  }
  getAssessList = (commnetType, page, append) => {
    var that = this
    app.getAssessList({
      method: 'post',
      data: {
        goods_id: that.data.goodsId,
        idx_arr: {
          idx: 'level',
          idx_value: commnetType
        },
        page: page,
        page_size: 20,
        sub_shop_app_id: this.data.franchiseeId || ''
      },
      success: function(res) {
        var commentData = res.data
        if (append) {
          commentData = that.data.commentArr.concat(commentData)
        }
        that.setData({
          commentArr: commentData,
          commentNums: res.num,
          commentPage: that.data.commentPage + 1,
          commentExample: res.data[0] || '',
          commentTotalPage: res.total_page,
          displayComment: +res.num[0] > 0 ? false : true,
          'rect[2].isShow': +res.num[0] > 0
        })
      }
    })
  }
  selectSubModel = e => {
    var dataset = e.target.dataset,
      modelIndex = dataset.modelIndex,
      submodelIndex = dataset.submodelIndex,
      data = {},
      selectModelsInfo = this.data.selectModelInfo,
      selectModels = this.data.selectModelInfo.models,
      model = this.data.goodsInfo.model,
      text = ''
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex]
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” '
        }
      }
    }
    data['selectModelInfo.models'] = selectModels
    data['selectModelInfo.models_text'] = text
    this.setData(data)
    this.resetSelectCountPrice()
  }
  resetSelectCountPrice = () => {
    var selectModelIds = this.data.selectModelInfo.models.join(','),
      modelItems = this.data.goodsInfo.model_items,
      discountInfo = this.data.discountInfo,
      groupType = this.data.goods.type,
      discountInfoArr = [],
      data = {}
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model) {
        if (modelItems[i].model == selectModelIds) {
          if (
            groupType == 4 ||
            (groupType != 4 &&
              modelItems[i].num_of_people == this.data.selectModelInfo.groupNum)
          ) {
            // 特殊处理：抽奖团没有成团人数
            data['selectModelInfo.stock'] = modelItems[i].stock
            data['selectModelInfo.virtualPrice'] =
              modelItems[i].virtual_price != '0.00' &&
              modelItems[i].virtual_price
                ? modelItems[i].virtual_price || ''
                : ''
            data['selectModelInfo.price'] = modelItems[i].price
            data['selectModelInfo.member_price'] =
              modelItems[i].member_price || 0
            data['selectModelInfo.leader_price'] =
              modelItems[i].leader_price || 0
            data['selectModelInfo.modelId'] = modelItems[i].id || ''
            data['selectModelInfo.imgurl'] = modelItems[i].img_url || ''
            break
          }
        }
      } else {
        if (
          groupType == 4 ||
          (groupType != 4 &&
            modelItems[i].num_of_people == this.data.selectModelInfo.groupNum)
        ) {
          data['selectModelInfo.stock'] = modelItems[i].stock
          data['selectModelInfo.price'] = modelItems[i].price
          data['selectModelInfo.virtualPrice'] =
            modelItems[i].virtual_price != '0.00' && modelItems[i].virtual_price
              ? modelItems[i].virtual_price
              : ''
          data['selectModelInfo.member_price'] = modelItems[i].member_price || 0
          data['selectModelInfo.leader_price'] = modelItems[i].leader_price || 0
          data['selectModelInfo.modelId'] = modelItems[i].id || ''
          data['selectModelInfo.imgurl'] = modelItems[i].img_url || ''
          break
        }
      }
    }
    for (let i = 0; i < discountInfo.length; i++) {
      if (
        discountInfo[i].model_id == data['selectModelInfo.modelId'] ||
        (discountInfo[i].model_id === undefined &&
          !data['selectModelInfo.modelId'])
      ) {
        discountInfoArr.push(discountInfo[i])
      }
    }
    data['discountInfoArr'] = discountInfoArr
    this.setData(data)
  }
  clickMinusButton = e => {
    var count = this.data.selectModelInfo.buyCount
    if (count <= 1) {
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count - 1,
      'selectModelInfo.groupBuyCount': count - 1
    })
  }
  sureJoinGroup = e => {
    let that = this
    if (!app.isLogin()) {
      app.goLogin({
        success: function() {
          that.sureJoinGroup(e)
        }
      })
      return
    }
    let franchiseeId = this.data.franchiseeId,
      selectmodel = JSON.stringify(this.data.selectModelInfo),
      goodsId = this.data.goodsId,
      activityId = this.data.activityId,
      modelId = this.data.selectModelInfo.modelId || '',
      num = this.data.selectModelInfo.groupBuyCount,
      numOfPeople = this.data.selectModelInfo.groupNum || '',
      sub_shop_app_id = franchiseeId || '',
      is_group_buy = 1,
      limit_buy = that.data.goods.user_limit_buy,
      team_token = that.data.team_token || ''
    if (this.data.selectModelInfo.stock == 0) {
      app.showModal({
        content: '商品库存不足'
      })
      return
    }
    if (that.data.goods.type == 3 && that.data.goods.is_leader == 0) {
      app.sendRequest({
        url: '/index.php?r=appGroupBuy/addOrder',
        method: 'post',
        data: {
          goods_id: goodsId,
          activity_id: activityId,
          sub_shop_app_id:
            that.data.franchiseeId || this.data.groupInfo.parent_app_id || '',
          model_id: modelId || '',
          num: num,
          num_of_people: numOfPeople,
          team_token: team_token,
          select_benefit: '',
          is_balance: 0,
          use_balance: 0,
          address_id: ''
        },
        success: function(res) {
          var data = res.data
          if (res.status == 0) {
            if (that.data.cashOnDelivery) {
              let pagePath =
                '/group/pages/gppaySuccess/gppaySuccess?detail=' +
                res.data.order_id +
                (that.franchisee_id
                  ? '&franchisee=' + that.franchisee_id
                  : '') +
                '&is_group=' +
                !!that.is_group +
                '&orderid=' +
                res.data.order_id +
                '&teamToken=' +
                res.data.team_token
              that.saveUserFormId(function() {
                app.turnToPage(pagePath, 1)
              })
            } else {
              that.payOrder(res.data.order_id, res.data.team_token)
            }
          } else {
            app.showModal({
              content: res.data
            })
            return
          }
        },
        fail: function() {
          that.requesting = false
        },
        successStatusAbnormal: function() {
          that.requesting = false
        }
      })
    } else {
      var pagePath =
        '/group/pages/previewGroupOrder/previewGroupOrder?goodsid=' +
        goodsId +
        '&activityid=' +
        that.data.activityId +
        '&num=' +
        num +
        '&modelId=' +
        modelId +
        '&numOfPeople=' +
        numOfPeople +
        '&is_group=true' +
        '&group_buy_people=' +
        that.data.selectModelInfo.groupNum +
        '&is_group_buy=' +
        is_group_buy +
        '&limit_buy=' +
        limit_buy +
        '&selectmodel=' +
        selectmodel +
        '&groupType=' +
        that.data.goods.type +
        '&team_token=' +
        team_token +
        '&isFrom=true' +
        (that.data.franchiseeId
          ? '&franchisee=' + that.data.franchiseeId
          : '') +
        '&parent_app_id=' +
        this.data.groupInfo.parent_app_id
      that.saveUserFormId(function() {
        franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
        that.setData({
          addToGroupBuyCart: true,
          isShowTopBar: true
        })
        app.turnToPage(pagePath)
      })
    }
  }
  payOrder = (orderId, teamToken) => {
    var that = this
    function paySuccess() {
      var pagePath =
        '/group/pages/gppaySuccess/gppaySuccess?detail=' +
        orderId +
        (that.data.franchiseeId
          ? '&franchisee=' + that.data.franchiseeId
          : '') +
        '&is_group=' +
        !!that.is_group +
        '&teamToken=' +
        teamToken
      if (!that.franchisee_id) {
        app.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId || ''
          },
          success: function(res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1'
            }
            that.saveUserFormId(function() {
              app.turnToPage(pagePath, 1)
            })
          }
        })
      } else {
        that.saveUserFormId(function() {
          app.turnToPage(pagePath, 1)
        })
      }
    }
    function payFail() {
      that.saveUserFormId(function() {
        app.turnToPage(
          '../pluginOrderDetail/pluginOrderDetail?order_id=' +
            orderId +
            (that.data.franchiseeId
              ? '&franchisee=' + that.data.franchiseeId
              : ''),
          1
        )
      })
    }
    if (this.data.totalPayment == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId || '',
          total_price: 0
        },
        success: function(res) {
          paySuccess()
        },
        fail: function() {
          payFail()
        },
        successStatusAbnormal: function() {
          payFail()
        }
      })
      return
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.data.franchiseeId || ''
      },
      success: function(res) {
        var param = res.data
        param.orderId = orderId
        param.success = paySuccess
        param.goodsType = 0
        param.fail = payFail
        app.wxPay(param)
      },
      fail: function() {
        payFail()
      },
      successStatusAbnormal: function() {
        payFail()
      }
    })
  }
  confirmPayment = e => {
    app.sendRequest({
      url: '/index.php?r=appGroupBuy/addOrder',
      method: 'post',
      data: {
        goods_id: that.data.goodsId,
        activity_id: that.data.activityId,
        sub_shop_app_id:
          that.data.franchiseeId || this.data.groupInfo.parent_app_id || '',
        model_id: (modelId = this.data.selectModelInfo.modelId || ''),
        num: this.data.selectModelInfo.groupBuyCount,
        num_of_people: this.data.selectModelInfo.groupNum || '',
        team_token: that.data.team_token || '',
        formId: e.target.formId,
        select_benefit: that.data.selectDiscountInfo,
        is_balance: that.data.useBalance ? 1 : 0,
        is_self_delivery: that.data.is_self_delivery,
        self_delivery_app_store_id:
          that.data.is_self_delivery == 1 ? that.data.selectDelivery.id : '',
        remark: that.data.description,
        address_id: that.data.selectAddress.id || that.data.selectDelivery.id,
        is_pay_on_delivery: that.data.cashOnDelivery ? 1 : 0,
        additional_info: that.additional_info,
        express_fee: that.data.express_fee
      },
      success: function(res) {
        var data = res.data
        if (res.status == 0) {
          if (that.data.cashOnDelivery) {
            let pagePath =
              '/group/pages/gppaySuccess/gppaySuccess?detail=' +
              res.data.order_id +
              (that.data.franchiseeId
                ? '&franchisee=' + that.data.franchiseeId
                : '') +
              '&is_group=' +
              !!that.is_group +
              '&orderid=' +
              res.data.order_id +
              '&teamToken=' +
              res.data.team_token
            that.saveUserFormId(function() {
              app.turnToPage(pagePath, 1)
            })
          } else {
            that.payOrder(res.data.order_id, res.data.team_token)
          }
        } else {
          app.showModal({
            content: res.data
          })
          return
        }
      },
      fail: function() {
        that.requesting = false
      },
      successStatusAbnormal: function() {
        that.requesting = false
      }
    })
  }
  clickPlusButton = e => {
    var type = e.currentTarget.dataset.type,
      selectModelInfo = this.data.selectModelInfo,
      goodsInfo = this.data.goodsInfo,
      count = selectModelInfo.buyCount,
      limit_buy = +this.data.goods.user_limit_buy,
      stock = selectModelInfo.stock
    if (
      limit_buy != 0 &&
      selectModelInfo.buyCount >= limit_buy &&
      type == 'group'
    ) {
      app.showModal({
        content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
      })
      this.setData({
        'selectModelInfo.buyCount': limit_buy,
        'selectModelInfo.groupBuyCount': limit_buy
      })
      return
    }
    if (count >= stock && this.data.goods.type != 4) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      this.setData({
        'selectModelInfo.buyCount': stock,
        'selectModelInfo.groupBuyCount': stock
      })
      return
    }
    this.setData({
      'selectModelInfo.buyCount': count + 1,
      'selectModelInfo.groupBuyCount': count + 1
    })
  }
  clickGroupMinusButton = e => {
    var count = this.data.selectModelInfo.groupBuyCount
    if (count <= 1) {
      return
    }
    this.setData({
      'selectModelInfo.groupBuyCount': count - 1
    })
  }
  clickGroupPlusButton = e => {
    var selectModelInfo = this.data.selectModelInfo,
      count = selectModelInfo.groupBuyCount,
      stock = selectModelInfo.stock,
      max = this.data.goods.user_limit_buy
    if (count >= stock || count >= max) {
      return
    }
    this.setData({
      'selectModelInfo.groupBuyCount': count + 1
    })
  }
  selectGroupNum = e => {
    this.setData({
      'selectModelInfo.groupNum': e.currentTarget.dataset.num
    })
    this.resetSelectCountPrice()
  }
  inputBuyCount = e => {
    var count = +e.target.value,
      selectModelInfo = this.data.selectModelInfo,
      goodsInfo = this.data.goodsInfo,
      stock = +selectModelInfo.stock,
      limit_buy = +this.data.goods.user_limit_buy
    if (count > limit_buy && limit_buy != 0) {
      app.showModal({
        content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
      })
      this.setData({
        'selectModelInfo.buyCount': +limit_buy,
        'selectModelInfo.groupBuyCount': +limit_buy
      })
      return
    }
    if (count == 0) {
      this.setData({
        'selectModelInfo.buyCount': 1
      })
      return
    }
    if (count >= stock) {
      app.showModal({
        content: '购买数量不能大于库存'
      })
      this.setData({
        'selectModelInfo.buyCount': +stock,
        'selectModelInfo.groupBuyCount': +stock
      })
      return
    }
    this.setData({
      'selectModelInfo.buyCount': +count,
      'selectModelInfo.groupBuyCount': +count
    })
  }
  clickPlusImages = e => {
    app.previewImage({
      current: e.currentTarget.dataset.src,
      urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
    })
  }
  goToHomepage = () => {
    let that = this
    let franchiseeId = that.data.franchiseeId
    let chainId = app.getChainId()
    if (franchiseeId && franchiseeId != chainId) {
      let pages = app.getCurrentPages()
      let p = pages[pages.length - 2]
      if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
        app.turnBack({
          delta: 2
        })
      } else {
        customEvent.clickEventHandler['to-franchisee']({
          'franchisee-id': franchiseeId
        })
      }
    } else {
      var router = app.getHomepageRouter()
      app.reLaunch({
        url: '/pages/' + router + '/' + router
      })
    }
  }
  changeImageOrVideo = event => {
    this.setData({
      videoPoster: false,
      imageOrVideo: event.currentTarget.dataset.type
    })
  }
  startPlayVideo = () => {
    let video = app.createVideoContext('carousel-video')
    this.setData({
      videoPoster: true
    })
    video.play()
  }
  addFavoriteGoods = event => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/addFavoriteGoods',
      data: {
        form_id: event.target.formId,
        goods_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      success: function(res) {
        _this.setData({
          'goods.is_favorite': 1
        })
      },
      complete: function() {
        app.showToast({
          title: '收藏成功!',
          image: '/images/favorites.png'
        })
      }
    })
  }
  deleteFavoriteGoods = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/deleteFavoriteGoods',
      method: 'post',
      data: {
        goods_id_arr: [_this.data.goodsId],
        sub_shop_app_id: _this.data.franchiseeId || ''
      },
      success: function(res) {
        _this.setData({
          'goods.is_favorite': 0
        })
      },
      complete: function() {
        app.showToast({
          title: '取消收藏!',
          image: '/images/cancel-favorites.png'
        })
      }
    })
  }
  sureAddToShoppingCart = () => {
    if (this.data.goods.type == 4) {
      app.showModal({
        content: '参与抽奖商品不能加入购物车'
      })
      return
    }
    var that = this,
      param = {
        goods_id: this.data.goodsId,
        model_id: this.data.selectModelInfo.modelId || '',
        num: this.data.selectModelInfo.buyCount,
        sub_shop_app_id: this.data.franchiseeId || '',
        is_seckill: this.data.isSeckill ? 1 : ''
      }
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function(res) {
        app.showToast({
          title: '添加成功',
          icon: 'success'
        })
        setTimeout(function() {
          that.hiddeAddToShoppingCart()
        }, 1000)
      }
    })
  }
  showGroupBuy = () => {
    let team_token = this.data.team_token,
      goodsInfo = this.data.goodsInfo
    if (goodsInfo.status == 4) {
      app.showModal({
        content: '当前拼团已结束'
      })
      return
    }
    if (
      goodsInfo.status == 0 ||
      goodsInfo.status == 1 ||
      goodsInfo.status == 2
    ) {
      app.showModal({
        content: '当前拼团活动未开启'
      })
      return
    }
    if (this.data.goods.type != 4) {
      team_token = ''
    }
    this.setData({
      team_token: team_token,
      addToGroupBuyCart: false,
      ifOpenNewGroup: false,
      isParticipate: false,
      isShowTopBar: false
    })
  }
  buyDirectlyNextStep = e => {
    var franchiseeId = this.data.franchiseeId,
      that = this,
      param = {
        goods_id: this.data.goodsId,
        model_id: this.data.selectModelInfo.modelId || '',
        num: this.data.selectModelInfo.buyCount,
        sub_shop_app_id: franchiseeId || '',
        is_seckill: this.data.isSeckill ? 1 : ''
      }
    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function(res) {
        var cart_arr = [res.data],
          pagePath =
            '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' +
            encodeURIComponent(cart_arr)
        that.saveUserFormId(function() {
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId)
          that.hiddeAddToShoppingCart()
          app.turnToPage(pagePath)
        })
      }
    })
  }
  remainMe = e => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=appShop/careActivity',
      data: {
        data_id: _this.data.goodsId,
        activity_id: _this.data.activityId,
        sub_shop_app_id: _this.data.franchiseeId || '',
        activity_type: 0
      },
      success: res => {
        var newdata = {}
        app.showToast({
          title: '提醒成功！',
          duration: 2000
        })
        newdata['goodsInfo.status'] = 2
        _this.setData(newdata)
      }
    })
    _this.saveUserFormId()
  }
  goToCommentPage = () => {
    var franchiseeId = this.data.franchiseeId,
      pagePath =
        '/eCommerce/pages/goodsComment/goodsComment?detail=' +
        this.data.goodsId +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    this.saveUserFormId(function() {
      app.turnToPage(pagePath)
    })
  }
  clickCommentLabel = e => {
    var commentType = e.target.dataset.type,
      data = {}
    data.commentPage = 1
    data.commnetType = commentType
    this.setData(data)
    this.getAssessList(commentType, 1)
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = callback => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: _this.data.franchiseeId || '',
        form_id: _this.data.formid || []
      },
      complete: function() {
        callback && callback()
        _this.setData({
          formid: []
        })
      }
    })
  }
  soonOpen = () => {
    app.showModal({
      content: '当前拼团未开启'
    })
  }

  componentDidMount() {}

  componentDidShow() {}

  componentDidHide() {}

  componentWillUnmount() {
    if (this.downcount) {
      this.downcount.clear()
    }
    if (this.downcountArr && this.downcountArr.length) {
      this.downcountArr = this.downcountArr.concat().reverse()
      for (let i = 0; i < this.downcountArr.length; i++) {
        this.downcountArr[i] && this.downcountArr[i].clear()
      }
    }
  }

  onPullDownRefresh = () => {}
  onReachBottom = () => {}
  onPageScroll = e => {
    let officialPageDom = this.officialPageRef.current;
    e = {
      ...e,
      scrollTop: officialPageDom.scrollTop,
      scrollLeft: officialPageDom.scrollLeft,
      scrollWidth: officialPageDom.scrollWidth,
      scrollHeight: officialPageDom.scrollHeight,
    }
    var _this = this,
      rect = this.data.rect,
      scrollTop = e.scrollTop,
      oldScrollTop = this.data.scrollTop,
      slidMask,
      topName = 'goods',
      showBottomKan,
      screenHeight = this.data.screenHeight
    for (let i = 0; i < rect.length; i++) {
      var topData = rect[i]
      if (topData && scrollTop + 40 > topData.top && topData.isShow !== false) {
        topName = topData.name
      }
    }
    this.setData({
      scrollType: topName,
      scrollTop: scrollTop
    })
  }
  onShareAppMessage = () => {
    var that = this,
      goodsId = this.data.goodsId,
      groupInfo = this.data.groupInfo,
      activityId = this.data.activityId,
      contact = this.data.contact,
      franchiseeId = this.data.franchiseeId,
      urlPromotion = app.globalData.PromotionUserToken
        ? '&user_token=' + app.globalData.PromotionUserToken
        : '',
      url =
        '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' +
        goodsId +
        '&activity_id=' +
        activityId +
        '&contact=' +
        contact +
        (franchiseeId ? '&franchisee=' + franchiseeId : '') +
        (app.globalData.pageShareKey
          ? '&psid=' + app.globalData.pageShareKey
          : '') +
        urlPromotion,
      share_cover = groupInfo.share_cover
        ? groupInfo.share_cover
        : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
      nickname = app.getUserInfo('nickname'),
      title = groupInfo.share_title
        ? groupInfo.share_title
        : (nickname ? nickname + ' 喊你' : '') +
          '拼单啦~ ' +
          this.data.groupInfo.group_buy_price +
          '元拼' +
          this.data.goodsInfo.title +
          '，火爆抢购中......'
    return app.shareAppMessage({
      title: title,
      path: url,
      imageUrl: share_cover,
      success: function(addTime) {
        app.showToast({
          title: '转发成功',
          duration: 500
        })
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: {
            sub_shop_app_id: _this.data.franchiseeId,
            add_time: addTime
          },
          success: function(res) {
            if (res.status == 0) {
              res.data &&
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                })
            }
          }
        })
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      topNavBarData,
      pageQRCodeData,
      scrollType,
      goodsInfo,
      displayComment,
      imageOrVideo,
      videoPoster,
      status,
      groupInfo,
      goods,
      progress,
      teamInfo,
      commentNums,
      commentExample,
      defaultPhoto,
      storeStyle,
      franchiseeId,
      sessionFrom,
      addToShoppingCartHidden,
      selectModelInfo,
      isShowVirtualPrice,
      isSeckill,
      addToGroupBuyCart,
      isParticipate,
      showTips,
      discountInfoArr,
      godos
    } = this.state
    return (
      <div ref={this.officialPageRef} className="official-page gp-goods-detail" onScroll={this.onPageScroll}>
        <TopNav title="商品详情" />
        <div
          className="transition"
          style={convertLineStyleData('top:' + topNavBarData.totalHeight + 'px;')}
        >
          <div data-type="goods" className="isRelative">
            <span className={scrollType == 'goods' ? 'active' : ''}>商品</span>
          </div>
          <div data-type="group" className="isRelative">
            <span className={scrollType == 'group' ? 'active' : ''}>拼团</span>
          </div>
          {!displayComment && (
            <div data-type="comment" className="isRelative">
              <span className={scrollType == 'comment' ? 'active' : ''}>
                评论
              </span>
            </div>
          )}
          <div data-type="detail" className="isRelative">
            <span className={scrollType == 'detail' ? 'active' : ''}>详情</span>
          </div>
        </div>
        <div className="goods-main">
          <div className="collage-goodsDetail">
            <div className="collage-section  goods-message" id="goods">
              {imageOrVideo == 'image' && (
                <div className="image-carousel-container">
                  {!(goodsInfo && goodsInfo.img_urls) ? (
                    <div className="goods-cover-container">
                      <img
                        data-src={goodsInfo && goodsInfo.cover}
                        onClick={this.clickPlusImages}
                        src={goodsInfo && goodsInfo.cover}
                      />
                    </div>
                  ) : (
                    <div className="slick-carousel-container">
                      <Carousel
                        dots={false}
                        infinite={true}
                        autoplay={true}
                        autoplayInterval={5000}
                        afterChange={this.carouselIndex}>
                        {goodsInfo.img_urls.map((item, index) => {
                          return (
                            <div key={index}>
                              <img
                                data-src={item}
                                data-srcarr={JSON.stringify(goodsInfo.img_urls)}
                                onClick={this.clickPlusImages}
                                className="slide-image"
                                src={item}
                                onLoad={() => {
                                  window.dispatchEvent(new Event('resize'));
                                }} />
                            </div>
                          )
                        })}
                      </Carousel>
                    </div>
                  )}
                  {goodsInfo && goodsInfo.video_url && (
                    <div className="image-video-menu">
                      <span
                        className={imageOrVideo == 'image' ? 'active' : ''}
                        data-type="image"
                        onClick={this.changeImageOrVideo}
                      >
                        图片
                      </span>
                      <span
                        className={imageOrVideo == 'video' ? 'active' : ''}
                        data-type="video"
                        onClick={this.changeImageOrVideo}
                      >
                        视频
                      </span>
                    </div>
                  )}
                </div>
              )}
              {goodsInfo && goodsInfo.video_url && imageOrVideo == 'video' && (
                <div className="video-carousel-container">
                  <video
                    src={goodsInfo.video_url}
                    id="carousel-video"
                    hidden={!videoPoster}
                  >
                    {goodsInfo.video_url && (
                      <CoverView className="image-video-menu">
                        <CoverView
                          className={imageOrVideo == 'image' ? 'active' : ''}
                          data-type="image"
                          onClick={this.changeImageOrVideo}
                        >
                          图片
                        </CoverView>
                        <CoverView
                          className={imageOrVideo == 'video' ? 'active' : ''}
                          data-type="video"
                          onClick={this.changeImageOrVideo}
                        >
                          视频
                        </CoverView>
                      </CoverView>
                    )}
                  </video>
                  <div className="videoele-cover-view" hidden={videoPoster}>
                    <div className="videoele-poster-wrap">
                      <img
                        className="videoele-poster"
                        src={goodsInfo.video_img}
                        mode="scaleToFill"
                      />
                    </div>
                    <div
                      className="videoele-play-icon"
                      onClick={this.startPlayVideo}
                    >
                      <img
                        className="videoele-play-image"
                        src="http://cdn.jisuapp.cn/static/webapp/images/play.png"
                        mode="scaleToFill"
                      />
                    </div>
                    <div className="image-video-menu">
                      <span
                        className={imageOrVideo == 'image' ? 'active' : ''}
                        data-type="image"
                        onClick={this.changeImageOrVideo}
                      >
                        图片
                      </span>
                      <span
                        className={imageOrVideo == 'video' ? 'active' : ''}
                        data-type="video"
                        onClick={this.changeImageOrVideo}
                      >
                        视频
                      </span>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={
                  'collage-price-info ' + (status == 1 ? 'ready' : 'start')
                }
              >
                <div className="content-wrap">
                  <div className="min-price">
                    <span>¥</span>
                    <span>{groupInfo && groupInfo.group_buy_price}</span>
                  </div>
                  <div className="origin-price">
                    {'¥' + (goodsInfo && (goodsInfo.virtual_price || goodsInfo.goods_price))}
                  </div>
                  <div className="remaining-time">
                    {goodsInfo && (goodsInfo.status == 0 ||
                    goodsInfo.status == 1 ||
                    goodsInfo.status == 2) ? (
                      <React.Fragment>
                        <div>距拼购开始还剩 :</div>
                        <div>
                          {goodsInfo.downCount.days != '00' &&
                            goodsInfo.downCount.days != '0' && (
                              <React.Fragment>
                                <span>{goodsInfo.downCount.days}</span>
                                <span>天</span>
                              </React.Fragment>
                            )}
                          <span>{goodsInfo.downCount.hours}</span>
                          <span>:</span>
                          <span style={convertLineStyleData('width:48rpx;')}>
                            {goodsInfo.downCount.minutes}
                          </span>
                          <span>:</span>
                          <span style={convertLineStyleData('width:48rpx;')}>
                            {goodsInfo.downCount.seconds}
                          </span>
                        </div>
                      </React.Fragment>
                    ) : (
                      goodsInfo &&
                      goodsInfo.status == 3 &&
                      goods.end_date != '-1' && (
                        <React.Fragment>
                          <div>距拼购结束还剩 :</div>
                          <div>
                            {goodsInfo.downCount.days != '00' &&
                              goodsInfo.downCount.days != '0' && (
                                <React.Fragment>
                                  <span>{goodsInfo.downCount.days}</span>
                                  <span>天</span>
                                </React.Fragment>
                              )}
                            <span>{goodsInfo.downCount.hours}</span>
                            <span>:</span>
                            <span style={convertLineStyleData('width:48rpx;')}>
                              {goodsInfo.downCount.minutes}
                            </span>
                            <span>:</span>
                            <span style={convertLineStyleData('width:48rpx;')}>
                              {goodsInfo.downCount.seconds}
                            </span>
                          </div>
                        </React.Fragment>
                      )
                    )}
                  </div>
                </div>
                <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/detail-mask.png" />
              </div>
              <div className="collage-title-info">
                <div className="title-info">
                  <div className="goods-title">
                    <div className="title">
                      <div className="classify-type">
                        <div>
                          <i className="ico-moon icon-number-people"></i>
                        </div>
                        <span>
                          {goods && goods.type == 0
                            ? groupInfo.num_of_people.length > 1
                              ? '多人团'
                              : groupInfo.num_of_people[0] + '人团'
                            : goods && goods.type == 1
                            ? '新人团'
                            : goods && goods.type == 2
                            ? '阶梯团'
                            : goods && goods.type == 3
                            ? '帮帮团'
                            : '抽奖团'}
                        </span>
                      </div>
                      {goodsInfo && goodsInfo.title}
                    </div>
                    <div
                      className="share-jbtn isRelative"
                      onClick={this.showQRCodeComponent}
                    >
                      <span className="ico-moon icon-news-sharefriends"></span>
                    </div>
                  </div>
                  {goods && goods.type != 4 && (
                    <div>{goods && goods.group_buy_discount_tips}</div>
                  )}
                </div>
              </div>
              {goods && goods.successful_team_leader.length > 0 && (
                <div className="successful_team_leader">
                  <div>
                    {goods.successful_team_leader.map((item, index) => {
                      return <img src={item} key={index} />
                    })}
                  </div>
                  <div>拼团成功啦</div>
                </div>
              )}
            </div>
            <div className="collage-section">
              <div className="express-info">
                {'运费 : ' + (goodsInfo && goodsInfo.express_fee)}
              </div>
              <div
                className="specification-info isRelative"
                onClick={this.showGroupBuy}
              >
                <div>选择产品规格</div>
                <div>
                  <span className="ico-moon icon-rightarrow"></span>
                </div>
              </div>
              <div className="goods-other-info">
                <label>取货方式</label>
                <div className="address-pick-up">
                  {goodsInfo && goodsInfo.pick_up_type.map((item, index) => {
                    return (
                      <div key={item}>
                        <span className="ico-moon icon-goods-support-delivery suporrt"></span>
                        <span>
                          {item == 1 ? '快递' : item == 2 ? '同城' : '自提'}
                        </span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            {goods && goods.type == 4 && goodsInfo.status == 3 && (
              <div className="collage-section progress-message">
                <div className="progress">
                  <div
                    className="success"
                    style={convertLineStyleData('width:' + progress + '%;')}
                  ></div>
                </div>
                <div className="tip">
                  <div>
                    <span>{goods.current_user_count}</span>人已参与
                  </div>
                  <div>{'满' + goods.max_user_num + '人开奖'}</div>
                </div>
              </div>
            )}
            <div className="collage-section" id="group">
              {teamInfo.count == 0 || (goods && goods.type == 3) || (goods && goods.type == 4) ? (
                <React.Fragment>
                  <div
                    className="collage-play-title isRelative"
                    onClick={this.goToPlaylaws}
                  >
                    <div>拼团玩法</div>
                    <div>
                      <span className="ico-moon icon-rightarrow"></span>
                    </div>
                  </div>
                  <div className="collage-play-category">
                    {goods.type == 0 ? (
                      <React.Fragment>
                        <div>
                          <span className="ico-moon icon-regiment-leader icon-step"></span>
                          <div>团长开团</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-invite-friends  icon-step"></span>
                          <div>邀请好友</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-group-success  icon-step"></span>
                          <div>拼团成功</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-wait-shipment  icon-step"></span>
                          <div>等待发货</div>
                        </div>
                      </React.Fragment>
                    ) : goods.type == 1 ? (
                      <React.Fragment>
                        <div>
                          <span className="ico-moon icon-regiment-leader icon-step"></span>
                          <div>团长开团</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-invite-news icon-step"></span>
                          <div>邀请新人</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-group-success icon-step"></span>
                          <div>拼团成功</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-wait-shipment icon-step"></span>
                          <div>等待发货</div>
                        </div>
                      </React.Fragment>
                    ) : goods.type == 2 ? (
                      <React.Fragment>
                        <div>
                          <span className="ico-moon icon-regiment-leader icon-step"></span>
                          <div>团长开团</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-invite-friends icon-step"></span>
                          <div>邀请好友</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-peoplemore-pricelow icon-step"></span>
                          <div>人数多价格低</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-wait-shipment icon-step"></span>
                          <div>等待发货</div>
                        </div>
                      </React.Fragment>
                    ) : goods.type == 3 ? (
                      <React.Fragment>
                        <div>
                          <span className="ico-moon icon-regiment-leader icon-step"></span>
                          <div>团长开团</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-friends-pay icon-step"></span>
                          <div>好友代付</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon icon-reach-num icon-step"></span>
                          <div>达到人数</div>
                        </div>
                        <div>
                          <span className="ico-moon icon-fillet-rectangle"></span>
                        </div>
                        <div>
                          <span className="ico-moon  icon-wait-shipment icon-step"></span>
                          <div>团长单独发货</div>
                        </div>
                      </React.Fragment>
                    ) : (
                      goods.type == 4 && (
                        <React.Fragment>
                          <div>
                            <span className="ico-moon  icon-regiment-leader icon-step"></span>
                            <div>团长开团</div>
                          </div>
                          <div>
                            <span className="ico-moon icon-fillet-rectangle"></span>
                          </div>
                          <div>
                            <span className="ico-moon icon-invite-friends icon-step"></span>
                            <div>邀请好友</div>
                          </div>
                          <div>
                            <span className="ico-moon icon-fillet-rectangle"></span>
                          </div>
                          <div>
                            <span className="ico-moon icon-reach-num icon-step"></span>
                            <div>达到人数</div>
                          </div>
                          <div>
                            <span className="ico-moon icon-fillet-rectangle"></span>
                          </div>
                          <div>
                            <span className="ico-moon icon-draw-lucky icon-step"></span>
                            <div>抽取幸运儿</div>
                          </div>
                        </React.Fragment>
                      )
                    )}
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div className="collage-section list-message">
                    <div className="title">
                      <span>{teamInfo.count + ' 人正在火拼中'}</span>
                      <div
                        className="collage-play-title isRelative"
                        onClick={this.goToPlaylaws}
                      >
                        <div>拼团玩法</div>
                        <div>
                          <span className="ico-moon icon-rightarrow"></span>
                        </div>
                      </div>
                    </div>
                    <div className="collage-list">
                      {teamInfo.team_list.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {item.current_status == 2 && (
                              <div
                                className="collage-item isRelative"
                                data-num={item.max_user_num}
                                data-token={item.team_token}
                                data-joined={item.joined}
                                data-type={item.activity_type}
                                onClick={this.participateGroup}
                              >
                                <div>
                                  <div className="image-wrap">
                                    <div>
                                      <img
                                        src={item.leader_info.cover_thumb}
                                      />
                                    </div>
                                    <div>
                                      <img src="http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/missing-head.png" />
                                    </div>
                                  </div>
                                  <div className="content-wrap">
                                    <div className="name">
                                      {item.leader_info.nickname}
                                    </div>
                                    <div className="status">
                                      <div className="condition">
                                        {item.activity_type == '2' ? (
                                          <React.Fragment>
                                            已拼
                                            <span>
                                              {item.current_user_count}
                                            </span>
                                            人
                                          </React.Fragment>
                                        ) : (
                                          <React.Fragment>
                                            还差
                                            <span>{item.need_user_count}</span>
                                            人
                                          </React.Fragment>
                                        )}
                                      </div>
                                      <div className="remain">
                                        {'距结束仅剩' +
                                          (item.downCount.days != '00' &&
                                          item.downCount.days != '0'
                                            ? (item.downCount.days || '')
                                            : '') +
                                          item.downCount.hours +
                                          ':' +
                                          item.downCount.minutes +
                                          ':' +
                                          item.downCount.seconds}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="btn-wrap">
                                  <button type="button">立即参团</button>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </div>
                    {teamInfo.is_more != 0 && (
                      <div className="show-more" onClick={this.showMoreTeams}>
                        查看更多
                        <span className="ico-moon icon-downarrow"></span>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              )}
            </div>
            <div className="collage-section shop-message">
              <div className="collage-shop-info">
                <div className="image-wrap">
                  <img src={goods && goods.app_cover} />
                </div>
                <div className="shop-info">
                  <div>{goods && goods.app_name}</div>
                  <div className="sales-num">
                    在售<span style={convertLineStyleData('color:#d2d2d2;margin:0 10rpx;')}>|</span>
                    <span>{goods && goods.total_goods}</span>件商品
                  </div>
                </div>
              </div>
              <div
                className="collage-shop-into isRelative"
                onClick={this.goToHomepage}
              >
                进入店铺
              </div>
            </div>
            <div
              className="collage-section  comment-message"
              hidden={displayComment}
              id="comment"
            >
              <div className="comment-title">
                <div>{'晒单评价 (' + ((commentNums && commentNums[0]) || 0) + ')'}</div>
                <div onClick={this.goToCommentPage}>查看全部 ></div>
              </div>
              <div className="block-item">
                {commentExample && (
                  <div>
                    <div className="comment-item">
                      <div>
                        <img
                          className="comment-user-photo"
                          src={commentExample.buyer_headimgurl || defaultPhoto}
                        />
                        <div>
                          <span className="commentPersonName">
                            {commentExample.buyer_nickname}
                          </span>
                          <div className="comment-date">
                            {commentExample.add_time}
                          </div>
                        </div>
                      </div>
                      <div className="comment-content">
                        {commentExample.assess_info.content}
                      </div>
                      {!!+commentExample.assess_info.has_img && (
                        <div className="comPage-comment-pics">
                          {commentExample.assess_info.img_arr.map(
                            (imgSrc, index) => {
                              return (
                                <img
                                  src={imgSrc}
                                  key={index}
                                  data-src={imgSrc}
                                  data-srcarr={
                                    JSON.stringify(commentExample.assess_info.img_arr)
                                  }
                                  onClick={this.clickPlusImages}
                                />
                              )
                            }
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="goods-detail-section" id="detail">
              <div className="goodsDetail-title">
                <div>商品详情</div>
              </div>
              <div className="goods-details rich-text" dangerouslySetInnerHTML={{__html: goods && goods.goods_info.description && goods.goods_info.description.replace(/href=".*?"/g,'')}}></div>
            </div>
          </div>
          <div className="collage-bottom">
            <div className="anthor-btn">
              {!franchiseeId && (
                <div className="form-contain goods-opt-item flex-sub-box-3">
                  <form>
                    <button type="button"
                            onClick={
                              goods && goods.is_favorite == 1
                                ? this.deleteFavoriteGoods
                                : this.addFavoriteGoods
                            }>
                      <div className="bottom-border-right">
                        <span
                          style={convertLineStyleData(
                            goods && goods.is_favorite == 1
                              ? 'color:' + storeStyle.theme
                              : ''
                          )}
                          className={
                            'ico-moon icon-' +
                            (goods && goods.is_favorite == 1
                              ? 'collect-solid'
                              : 'goods-detail-favorites')
                          }
                        ></span>
                        <div>收藏</div>
                      </div>
                    </button>
                  </form>
                </div>
              )}
              <div
                className={
                  'goods-opt-item flex-sub-box-' + (franchiseeId ? '2' : '3')
                }
              >
                <div
                  className="ico-moon icon-service2"
                  style={convertLineStyleData('font-size:36rpx;')}
                >
                  {/* TODO <ContactButton
                    type="default-dark"
                    size="20"
                    sessionFrom={sessionFrom}
                  ></ContactButton> */}
                </div>
                <div>客服</div>
              </div>
            </div>
            <div className="group-buy-btn">
              {!(goods && goods.type == 4 && goods.can_buy_alone == 0) && (
                <div className="separate-purchase isRelative">
                  <div onClick={this.singleBuy}>
                    <div>{'¥' + (goodsInfo && goodsInfo.goods_price)}</div>
                    <span>单独购买</span>
                  </div>
                </div>
              )}
              {goodsInfo && goodsInfo.status == 0 ? (
                <div className="soon-draw isRelative" onClick={this.soonOpen}>
                  <div>
                    <div>{'¥' + groupInfo.group_buy_price}</div>
                    <span>即将开团</span>
                  </div>
                </div>
              ) : goodsInfo && goodsInfo.status == 1 ? (
                <div className="reminded isRelative" onClick={this.remainMe}>
                  <div>
                    <div>{'¥' + groupInfo.group_buy_price}</div>
                    <span>提醒我</span>
                  </div>
                </div>
              ) : goodsInfo && goodsInfo.status == 2 ? (
                <div className="reminded isRelative">
                  <div>
                    <div>{'¥' + groupInfo.group_buy_price}</div>
                    <span>已提醒</span>
                  </div>
                </div>
              ) : (
                goodsInfo && (goodsInfo.status == 3 || goodsInfo.end_date != -1) && (
                  <div
                    className="group-buying isRelative"
                    onClick={this.showGroupBuy}
                  >
                    <div>
                      <div>{'¥' + groupInfo.group_buy_price}</div>
                      <span>{goods.type == 4 ? '参与抽奖' : '拼团购'}</span>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
          <div
            id="payDialog"
            className="page-dialog-wrap"
            hidden={addToShoppingCartHidden}
          >
            <div className="page-bottom-dialog">
              <div
                className="pay-close-dialog page-dialog-close"
                onClick={this.hiddeAddToShoppingCart}
              >
                <span className="ico-moon icon-closes"></span>
              </div>
              <div className="dialog-goods-header">
                <div>
                  <div className="thumb">
                    <div className="thumb-wrap">
                      <img
                        data-src={selectModelInfo.imgurl || (goodsInfo && goodsInfo.cover)}
                        onClick={this.clickPlusImages}
                        className="pay-goods-cover"
                        src={selectModelInfo.imgurl || (goodsInfo && goodsInfo.cover)}
                      />
                    </div>
                  </div>
                  <div className="pay-goods-baseinfo">
                    <div className="pay-goods-price">
                      <div className="pay-current-price">
                        {selectModelInfo.price != '0.00' && (
                          <div style={convertLineStyleData('font-size:28rpx;')}>
                            {'¥' + selectModelInfo.price}
                          </div>
                        )}
                        {/*  <text class="goods-price-discount" wx:if="{{ priceDiscountStr != '' }}">{{ priceDiscountStr }}</text>  */}
                        {isShowVirtualPrice &&
                          selectModelInfo.virtualPrice != 0 && (
                            <span className="virtualPrice">
                              {'¥' + selectModelInfo.virtualPrice}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="pay-goods-stock">
                      {'库存 ' + selectModelInfo.stock}
                    </div>
                    {selectModelInfo.models_text && (
                      <div className="pay-checked-text clearfix">
                        {'已选 :' + selectModelInfo.models_text}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="payDialog-content">
                <div
                  className="pay-goods-models"
                  hidden={!(goodsInfo && goodsInfo.model_items.length)}
                >
                  {goodsInfo && goodsInfo.model.map((model, modelIndex) => {
                    return (
                      <div key={modelIndex}>
                        <span className="model-title">{model.name}</span>
                        <label className="pills-list">
                          {model.subModelName.map((name, index) => {
                            return (
                              <label
                                key={index}
                                data-model-index={modelIndex}
                                data-submodel-index={index}
                                className={
                                  'subModel ' +
                                  (selectModelInfo.models[modelIndex] ==
                                  model.subModelId[index]
                                    ? 'select'
                                    : '')
                                }
                                data-submodel-id={model.subModelId[index]}
                                onClick={this.selectSubModel}
                              >
                                {name}
                              </label>
                            )
                          })}
                        </label>
                      </div>
                    )
                  })}
                </div>
                <div
                  className="payDialog-buy-num"
                  style={convertLineStyleData('padding-left:10px;padding-right:10px;')}
                >
                  <div className="clearfix">
                    <span>购买数量 :</span>
                    <div className="pull-right">
                      <div className="quantity pull-left">
                        <label
                          className={
                            'minus ' +
                            (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                          }
                        ></label>
                        <input
                          className="pay-buy-count"
                          type="number"
                          className="txt"
                          value={selectModelInfo.buyCount}
                          onChange={this.inputBuyCount}
                        />
                        <label
                          className={
                            'plus ' +
                            (selectModelInfo.buyCount >=
                              selectModelInfo.stock ||
                            (isSeckill &&
                              selectModelInfo.buyCount >=
                                goodsInfo.seckill_buy_limit)
                              ? 'disabled'
                              : '')
                          }
                        ></label>
                        <div
                          className="response-area response-area-minus"
                          onClick={this.clickMinusButton}
                        ></div>
                        <div
                          className="response-area response-area-plus"
                          onClick={this.clickPlusButton}
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dialog-bottom noGroupSureMask">
                <div>
                  <div
                    className="pay-add-to-shoppingcart isRelative"
                    onClick={this.sureAddToShoppingCart}
                  >
                    加入购物车
                  </div>
                </div>
                <div>
                  <div
                    className="btn-orange pay-buy-next isRelative"
                    onClick={this.buyDirectlyNextStep}
                  >
                    立即购买
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            id="groupPayDialog"
            className="page-dialog-wrap"
            hidden={addToGroupBuyCart}
            onClick={this.hideMask}
          >
            <div className="page-bottom-dialog">
              <div
                className="pay-close-dialog page-dialog-close"
                onClick={this.hideGroupBuyCart}
              >
                <span className="ico-moon icon-closes"></span>
              </div>
              <div className="dialog-goods-header">
                <div>
                  <div className="thumb">
                    <div className="thumb-wrap">
                      <img
                        data-src={selectModelInfo.imgurl || (goodsInfo && goodsInfo.cover)}
                        onClick={this.clickPlusImages}
                        className="pay-goods-cover"
                        src={selectModelInfo.imgurl || (goodsInfo && goodsInfo.cover)}
                      />
                    </div>
                  </div>
                  <div className="pay-goods-baseinfo">
                    <div className="pay-goods-price">
                      <div className="pay-current-price groupMaskPrice">
                        {goods && goods.type != 4 ? (
                          <React.Fragment>
                            {goods.is_leader == 0 || isParticipate ? (
                              <React.Fragment>
                                <div className="type">
                                  <span className="ico-moon icon-number-people"></span>
                                  团员价
                                </div>
                                <div style={convertLineStyleData('width:calc(100% - 104rpx);')}>
                                  <div className="member_price">
                                    {'¥' + selectModelInfo.member_price}
                                  </div>
                                  <div className="price">
                                    {'¥' +
                                      (selectModelInfo.virtualPrice ||
                                        selectModelInfo.price)}
                                  </div>
                                </div>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <div className="type">
                                  <span className="ico-moon icon-leader-logo"></span>
                                  团长价
                                </div>
                                <div style={convertLineStyleData('width:calc(100% - 104rpx);')}>
                                  <div className="leader_price">
                                    {'¥' + selectModelInfo.leader_price}
                                  </div>
                                  <div className="price">
                                    {'¥' +
                                      (selectModelInfo.virtualPrice ||
                                        selectModelInfo.price)}
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <div className="type">
                              <span className="ico-moon icon-number-people"></span>
                              抽奖团
                            </div>
                            <div className="member_price">
                              {'¥' + (groupInfo && groupInfo.group_buy_price)}
                            </div>
                            <div className="price">
                              {'¥' +
                                (selectModelInfo.virtualPrice ||
                                  (goodsInfo && goodsInfo.price))}
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                    <div className="pay-goods-stock">
                      {'库存 ' + selectModelInfo.stock}
                    </div>
                    {selectModelInfo.models_text && (
                      <div className="pay-checked-text clearfix">
                        {'已选 :' + selectModelInfo.models_text}
                      </div>
                    )}
                  </div>
                </div>
                <div className="tip">
                  {goods && (goods.type == 0 || goods.type == 1 || goods.type == 3) ? (
                    <React.Fragment>
                      <div>
                        {'成团人数: ' + selectModelInfo.groupNum + '人团'}
                      </div>
                    </React.Fragment>
                  ) : goods && goods.type == 2 ? (
                    <React.Fragment>
                      <div>
                        TIPS :
                        {goods.current_user_count ? (
                          <React.Fragment>
                            {'已拼' +
                              goods.current_user_count +
                              '人，人数越多，价格越低'}
                          </React.Fragment>
                        ) : (
                          <React.Fragment>人数越多，价格越低</React.Fragment>
                        )}
                      </div>
                      <div
                        className="showMoreTips"
                        onClick={(e) => {this.showMoreTips(e);e.stopPropagation()}}
                      >
                        查看更多
                        {showTips ? (
                          <span className="ico-moon icon-downarrow"></span>
                        ) : (
                          <span className="ico-moon icon-uparrow"></span>
                        )}
                        <div className="mask-tips" hidden={showTips}>
                          {discountInfoArr.map((item, index) => {
                            return (
                              <div key={index}>
                                <span>{'满' + item.num_of_people + '人'}</span>
                                <span>
                                  {'¥' +
                                    (isParticipate
                                      ? item.member_price
                                      : item.leader_price)}
                                </span>
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </React.Fragment>
                  ) : (
                    goods && goods.type == 4 && (
                      <React.Fragment>
                        <div>{'TIPS : 满' + goods.least_cost + '元开奖'}</div>
                      </React.Fragment>
                    )
                  )}
                </div>
              </div>
              <div className="payDialog-content">
                {goods && goods.type == 0 && !isParticipate && (
                  <div className="pay-goods-models">
                    <div className="group-info group-buy-num">
                      <div className="model-title">成团人数</div>
                      <label className="pills-list">
                        {groupInfo.num_of_people.map((num, index) => {
                          return (
                            <label
                              key={index}
                              className={
                                'subModel ' +
                                (selectModelInfo.groupNum == num
                                  ? 'select'
                                  : '') +
                                ' isRelative'
                              }
                              data-num={num}
                              onClick={this.selectGroupNum}
                            >
                              {num + '人团'}
                            </label>
                          )
                        })}
                      </label>
                    </div>
                  </div>
                )}
                <div
                  className="pay-goods-models"
                  hidden={!(goodsInfo && goodsInfo.model_items.length)}
                >
                  {goodsInfo && goodsInfo.model.map((model, modelIndex) => {
                    return (
                      <div key={modelIndex}>
                        <span className="model-title">{model.name}</span>
                        <label className="pills-list">
                          {model.subModelName.map((name, index) => {
                            return (
                              <label
                                key={index}
                                data-model-index={modelIndex}
                                data-submodel-index={index}
                                className={
                                  'subModel ' +
                                  (selectModelInfo.models[modelIndex] ==
                                  model.subModelId[index]
                                    ? 'select'
                                    : '')
                                }
                                data-submodel-id={model.subModelId[index]}
                                onClick={this.selectSubModel}
                              >
                                {name}
                              </label>
                            )
                          })}
                        </label>
                      </div>
                    )
                  })}
                </div>
                <div className="payDialog-buy-num">
                  <div className="clearfix">
                    <span>购买数量</span>
                    <div className="pull-right">
                      <div className="quantity pull-left">
                        <label
                          className={
                            'minus ' +
                            (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                          }
                        ></label>
                        <input
                          className="pay-buy-count"
                          type="number"
                          className="txt"
                          value={selectModelInfo.buyCount}
                          onChange={this.inputBuyCount}
                        />
                        <label
                          className={
                            'plus ' +
                            (selectModelInfo.buyCount >=
                              selectModelInfo.stock ||
                            (isSeckill &&
                              selectModelInfo.buyCount >=
                                goodsInfo.seckill_buy_limit)
                              ? 'disabled'
                              : '')
                          }
                        ></label>
                        <div
                          className="response-area response-area-minus"
                          onClick={this.clickMinusButton}
                        >
                        </div>
                        <div
                          className="response-area response-area-plus"
                          onClick={this.clickPlusButton}
                          data-type="group"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dialog-bottom groupSureMask">
                <div>
                  {goods && (goods.is_leader == 0 || isParticipate) ? (
                    <div
                      className="pay-add-to-shoppingcart isRelative"
                      onClick={this.sureJoinGroup}
                    >
                      马上参团
                    </div>
                  ) : (
                    <div
                      className="pay-add-to-shoppingcart isRelative"
                      onClick={this.sureJoinGroup}
                    >
                      {(goods && goods.type == 4) ? '参与抽奖' : '马上开团'}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/gp-goods-detail/GpGoodsDetail.jsx